import {NgIf} from '@angular/common';
import {
	Component,
	Input,
	ChangeDetectionStrategy,
	HostBinding,
} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';

/**
 * Embedded SVG icon using pre-registered icons from IconsService.
 * Check property "svg" for technical information.
 *
 * @author louiiuol
 */
@Component({
	standalone: true,
	imports: [NgIf, MatIconModule],
	selector: 'green-icon',
	template: `<mat-icon
			class="!w-full"
			inline
			*ngIf="svg"
			[svgIcon]="svg"
			aria-hidden="false" />
		<mat-icon *ngIf="!svg" class="!w-full" aria-hidden="false">
			<ng-content></ng-content>
		</mat-icon>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
	/**
	 * Defines icon to be shown. Must match a name registered in IconsService.
	 */
	@Input() svg?: string;

	@HostBinding('class')
	protected readonly class = 'inline-block';
}
